module.exports = __webpack_public_path__ + "static/responsive-819a8cab7d44b4f691a59905c3a51867.png";